import * as types from '../../index';

export const aflt_stcbonusListAction = (data) => {
    return {
    type: types.STCBONUS_LIST_AFFILIATE,
    data
    }
};

export const aflt_stcbonusAddAction = (data) => {
    return {
    type: types.STCBONUS_ADD_AFFILIATE,
    data
    }
};

export const aflt_stcbonusUpdateAction = (data) => {
    return {
    type: types.STCBONUS_UPDATE_AFFILIATE,
    data
    }
};

export const aflt_stcbonusDeleteAction = (data) => {
    return {
    type: types.STCBONUS_DELETE_AFFILIATE,
    data
    }
};
